
import { FaArrowRight, FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

export const socialLinks = [
    { icon: FaLinkedinIn, link: "https://www.linkedin.com/company/samrat-tech-it-solutions/?viewAsMember=true" },
    { icon: FaInstagram, link: "https://www.instagram.com/samrat_tech_it_solutions/" },
    { icon: FaFacebookF, link: "https://www.facebook.com/SamratTechItSolutions" },
    { icon: FaXTwitter, link: "https://x.com/samrattechitsol" },
  ];